import { Injectable } from "@nestjs/common";
import { AssetCheckList } from "./checklist.entity";
import { AssetChecklistDto } from "../dto/checklist.dto";

@Injectable()
export class AssetChecklistAdapter{
    public convertDtotoAssetChecklistEntity(assetChecklistDto:AssetChecklistDto,isUpdate: boolean = false) : AssetCheckList{
        const assetChecklist = new AssetCheckList();
        assetChecklist.checkListId = assetChecklistDto.checkListId;
        assetChecklist.checkListName = assetChecklistDto.checkListName;
        assetChecklist.assetCategory = assetChecklistDto.assetCategory;
        assetChecklist.versionFlag = assetChecklistDto.versionFlag;
        assetChecklist.isActive=assetChecklistDto.isActive==undefined?true:assetChecklistDto.isActive;
        if (isUpdate) {
            assetChecklist.updatedUser = assetChecklistDto.updatedUser;
        } else {
            assetChecklist.isActive = true;
            assetChecklist.createdUser =assetChecklistDto.createdUser;
        }

        return assetChecklist;

    }
   
    public convertEntitytoAssetChecklistDto(assetChecklist:AssetCheckList) : AssetChecklistDto{
        const assetChecklistDto = new AssetChecklistDto();
        assetChecklistDto.checkListId = assetChecklist.checkListId;
        assetChecklistDto.checkListName = assetChecklist.checkListName;
        assetChecklistDto.assetCategory = assetChecklist.assetCategory;
        assetChecklistDto.isActive = assetChecklist.isActive;
        assetChecklistDto.createdAt = assetChecklist.createdAt;
        assetChecklistDto.createdUser = assetChecklist.createdUser;
        assetChecklistDto.updatedAt = assetChecklist.updatedAt;
        assetChecklistDto.updatedUser = assetChecklist.updatedUser;
        assetChecklistDto.versionFlag = assetChecklist.versionFlag;
      
        return assetChecklistDto;

    }

 
}